import { render, staticRenderFns } from "./ReOpenConfirmModal.vue?vue&type=template&id=63a4213f&scoped=true&"
import script from "./ReOpenConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ReOpenConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a4213f",
  null
  
)

export default component.exports